import { EditStatusKpiModal } from "@/containers/Project/components";
import {
  ProjectStatusBadgeWrapper,
  StatusBadgeLabel,
  StyledStatusBadge,
} from "@/containers/Project/components/ProjectHeader/styled";
import KpiStatusColors from "@/enums/KpiStatusColors";
import ProjectUserPermissions from "@/enums/ProjectUserPermissions";
import { useProjectContext } from "@/providers";
import { BadgeStatus } from "@/types";
import { Row } from "antd";
import { useState } from "react";

interface IProps {
  status: BadgeStatus;
  label: string;
}

export const StatusBadge = ({ status, label }: IProps) => {
  const { canUser } = useProjectContext();
  const [editKpiModalOpen, setEditKpiModalOpen] = useState(false);

  const canEdit = canUser(ProjectUserPermissions.EditStatusKpis);

  const handleEdit = (): void => {
    if (!canEdit) return;

    setEditKpiModalOpen(true);
  };

  return (
    <>
      <ProjectStatusBadgeWrapper>
        <Row
          data-test-id={`status-badge-open-kpi-edit-${label}`}
          justify="center"
          onClick={handleEdit}
        >
          <StyledStatusBadge $editable={canEdit} status={status} />
        </Row>
        <Row justify="center">
          <StatusBadgeLabel>{label}</StatusBadgeLabel>
        </Row>
      </ProjectStatusBadgeWrapper>

      <EditStatusKpiModal
        isOpen={editKpiModalOpen}
        onCancel={(): void => setEditKpiModalOpen(false)}
        availableStatuses={Object.keys(KpiStatusColors).filter(
          (option) =>
            KpiStatusColors[option as keyof typeof KpiStatusColors] !==
            "default"
        )}
        kpi={label}
        currentStatus={
          Object.keys(KpiStatusColors).find(
            (current) =>
              KpiStatusColors[current as keyof typeof KpiStatusColors] ===
              status
          ) || KpiStatusColors.Gray
        }
      />
    </>
  );
};
